import { useState } from "react";
import PropTypes from "prop-types";
import useSendData from "../../../hooks/useSendData.js";
import { NOT_FOUND_MENU_MSG } from "../../../../constants.js";
import { formatMessageDataV2 } from "../../../utils/formatData.js";
import { useDispatch, useSelector } from "react-redux";
import { concatMessage, setLoadingReply } from "../../../features/messagesSlice.js";

SelectionMessage.propTypes = {
    message: PropTypes.object.isRequired,
};

export default function SelectionMessage({ message }) {

    const [selected, setSelected] = useState(false);
    const deviceId = useSelector(state => state.session.deviceId);
    const position = useSelector(state => state.messages.position);
    const { sendMessage } = useSendData();
    const dispatch = useDispatch();

    const handleClick = (value) => {

        if (!selected && value.productName !== "Not seeing your card? Click here.") {
            sendMessage(value, "selection");

        } else if (!selected && value.productName === "Not seeing your card? Click here.") {
            const botReply = formatMessageDataV2(deviceId, "bot", NOT_FOUND_MENU_MSG, position, true);
            dispatch(concatMessage(botReply));
            dispatch(setLoadingReply(false));
        }
        setSelected(true);
        
    };

    return (
        <li className="selection">
            {message.content.map((item, index) => (
                <div key={index} className="selection-item">
                    {item.productName !== "Not seeing your card? Click here." ? 
                        <span onClick={() => handleClick(item)}>
                            {item.productName} - {item.accountNumber}
                        </span> : 
                        <span onClick={() => handleClick(item)}>
                            {item.productName}
                        </span>
                    }
                </div>
            ))}
        </li>
    );
};
